import React from 'react';

export const allowedImageTypes = ['image/x-png', 'image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
const fileTypes = ['JPG', 'PNG', 'GIF'];

export const allowedTmageTypesMsg = `File format is not allowed. Please try ${fileTypes.join(', ')}`;

export const imgTooltipLabel = <span>Accepted Files: {fileTypes.join(', ')}<br />Max Size: 5MB</span>;
